import React from 'react';
import HeroEditor from './editors/HeroEditor';
import AboutEditor from './editors/AboutEditor';
import ServicesEditor from './editors/ServicesEditor';
import PortfolioEditor from './editors/PortfolioEditor';
import StepsEditor from './editors/StepsEditor';
import WhyChooseUsEditor from './editors/WhyChooseUsEditor';
import ContactEditor from './editors/ContactEditor';
import FooterEditor from './editors/FooterEditor';
import NavbarEditor from './editors/NavbarEditor';
import MessagesEditor from './editors/MessagesEditor';
import SettingsEditor from './editors/SettingsEditor';
import SocialMediaEditor from './editors/SocialMediaEditor';
import ContactDetailsEditor from './editors/ContactDetailsEditor';
import './DashboardContent.css';

const DashboardContent = ({ activeSection, user }) => {
  const getSectionTitle = (section) => {
    const titles = {
      'hero': 'القسم الرئيسي',
      'about': 'قسم من نحن',
      'services': 'الخدمات',
      'portfolio': 'المشاريع',
      'steps': 'قسم الخطوات',
      'why-choose-us': 'لماذا تختارنا',
      'contact': 'قسم التواصل',
      'footer': 'التذييل',
      'navbar': 'القائمة',
      'messages': 'الرسائل',
      'settings': 'الإعدادات',
      'social-media': 'التواصل الاجتماعي',
      'contact-details': 'بيانات التواصل'
    };
    return titles[section] || 'قسم غير موجود';
  };

  const renderEditor = () => {
    switch (activeSection) {
      case 'hero':
        return <HeroEditor />;
      case 'about':
        return <AboutEditor />;
      case 'services':
        return <ServicesEditor />;
      case 'portfolio':
        return <PortfolioEditor />;
      case 'steps':
        return <StepsEditor />;
      case 'why-choose-us':
        return <WhyChooseUsEditor />;
      case 'contact':
        return <ContactEditor />;
      case 'footer':
        return <FooterEditor />;
      case 'navbar':
        return <NavbarEditor />;
      case 'messages':
        return <MessagesEditor />;
      case 'settings':
        return <SettingsEditor user={user} />;
      case 'social-media':
        return <SocialMediaEditor />;
      case 'contact-details':
        return <ContactDetailsEditor />;
      default:
        return <div>القسم غير موجود</div>;
    }
  };

  return (
    <div className="dashboard-content">
      <div className="dashboard-content-header">
        <h1>{getSectionTitle(activeSection)}</h1>
      </div>
      <div className="dashboard-content-body">
        {renderEditor()}
      </div>
    </div>
  );
};

export default DashboardContent;

